import React from 'react';
import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import './Downtime.scss';
import moment from 'moment/moment';

function Downtime({ dtData }) {
    const data = [{ category: '계획 비가동', time: dtData.plannedDowntime ?? 0, fill: '#0070C0' }, { category: '계획 외 비가동', time: dtData.unplannedDowntime ?? 0, fill: '#2CB6B3' }]
    const formatSeconds = (seconds) => {
        const duration = moment.duration(seconds, 'seconds');
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        return `${hours}h ${minutes}m`;
    };



    const CustomLabel = ({ x, y, width, height, value }) => {
        const label = formatSeconds(value);
        return (
            <text
                x={width <= 50 ? 185 : x + width / 2}
                y={y + height / 2 + 4}
                textAnchor="middle"
                fill={width <= 50 ? "black" : "white"}
                fontSize={14}
            >
                {label}
            </text>
        );
    };
    return (
        <div className='downtime statusPanel'>
            <h3 className='psPanelTitle'>비가동 현황</h3>
            <p className={`currentStatus ${dtData.isDisconnected ? '' : dtData.isRunning ? "on" : "off"}`}>{dtData.isDisconnected ? '연결 확인 필요' : dtData.isRunning ? '생산 작업 중' : '비가동 중'}</p>
            <div className='panConArea'>
                <div className='latest24h'>
                    <p className='l24h'>최근 24시간</p>
                    <p className='value'>{formatSeconds(dtData.totalDowntime ?? 0)}</p>
                </div>
                <div className='isPlannedChartArea'>
                    <ResponsiveContainer>
                        <BarChart
                            layout='vertical'
                            data={data}
                            // barCategoryGap="8px"
                            barCategoryGap={4}
                        >
                            <XAxis
                                hide
                                dataKey={'time'}
                                type='number'
                                domain={[0, (dataMax) => dataMax]}
                            />
                            <YAxis
                                axisLine={false}
                                dataKey={'category'}
                                type='category'
                                width={100}
                                tickMargin={10}
                                tickSize={0}
                            />
                            <Bar
                                // barSize={36}
                                dataKey={'time'}
                            >
                                <LabelList dataKey="time" content={<CustomLabel />} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

        </div>
    );
}

export default Downtime;